import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GroupLockRequestResultDto, IsLockedLockInfoDto, LockRequestResultDto, LockTypeRequestDto } from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class LockRepository {
  constructor(
    private httpClientService: PrmHttpClientService,
  ) { }

  putGroupLock(
    objectId: string,
    lockType: string,
    lastRead?: string,
    instanceId?: string,
    tabId?: string,
  ): Observable<GroupLockRequestResultDto> {
    let params = new HttpParams();
    if(instanceId)
    {
        params = params.set('instanceId', encodeURIComponent(instanceId));
    }
    if(tabId)
    {
        params = params.set('tabId', encodeURIComponent(tabId));
    }
    const endpointUrl = `locks/group/${objectId}/${lockType}/${lastRead}?${params.toString()}`;
    return this.httpClientService.sendPutRequest(endpointUrl, null);
  }

  putGroupLocks(
    objectIds: string[],
    lockType: string,
    lastRead?: string,
    instanceId?: string,
    tabId?: string,
  ): Observable<GroupLockRequestResultDto[]> {
    let params = new HttpParams();
    if(instanceId)
    {
      params = params.set('instanceId', encodeURIComponent(instanceId));
    }
    if(tabId)
    {
      params = params.set('tabId', encodeURIComponent(tabId));
    }
    const endpointUrl = `locks/group/${lockType}/${lastRead}?${params.toString()}`;
    return this.httpClientService.sendPutRequest(endpointUrl, objectIds);
  }

  putGroupLocksByLockTypes(
    lockRequest: LockTypeRequestDto[],
    lastRead?: string,
    instanceId?: string,
    tabId?: string,
  ): Observable<GroupLockRequestResultDto[]> {
    let params = new HttpParams();
    if(instanceId)
    {
      params = params.set('instanceId', encodeURIComponent(instanceId));
    }
    if(tabId)
    {
      params = params.set('tabId', encodeURIComponent(tabId));
    }
    const endpointUrl = `locks/group/lock-types/${lastRead}?${params.toString()}`;
    return this.httpClientService.sendPutRequest(endpointUrl, lockRequest);
  }

  putGroupUnlock(instanceId: string, tabId?: string): Observable<void> {
    let params = new HttpParams();
    if(tabId)
    {
      params = params.set('tabId', encodeURIComponent(tabId));
    }
    const endpointUrl = `locks/groupunlock/${instanceId}?${params.toString()}`;
    return this.httpClientService.sendPutRequest(endpointUrl, null);
  }

  getLock(objectId: string, lockType: string, instanceId?: string, tabId?: string): Observable<IsLockedLockInfoDto> {
    let params = new HttpParams();
    if(instanceId)
    {
      params = params.set('instanceId', encodeURIComponent(instanceId));
    }
    if(tabId)
    {
      params = params.set('tabId', encodeURIComponent(tabId));
    }
    const endpointUrl = `locks/${objectId}/${lockType}?${params.toString()}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  putLock(objectId: string, lockType: string, instanceId?: string, tabId?: string): Observable<LockRequestResultDto> {
    let params = new HttpParams();
    if(instanceId)
    {
      params = params.set('instanceId', encodeURIComponent(instanceId));
    }
    if(tabId)
    {
        params = params.set('tabId', encodeURIComponent(tabId));
    }
    const endpointUrl = `locks/${objectId}/${lockType}?${params.toString()}`;
    return this.httpClientService.sendPutRequest(endpointUrl, null);
  }

  deleteLock(objectId: string, lockType: string, instanceId?: string, tabId?: string): Observable<void> {
    let params = new HttpParams();
    if(instanceId)
    {
      params = params.set('instanceId', encodeURIComponent(instanceId));
    }
    if(tabId)
    {
      params = params.set('tabId', encodeURIComponent(tabId));
    }
    const endpointUrl = `locks/${objectId}/${lockType}?${params.toString()}`;
    return this.httpClientService.sendDeleteRequest(endpointUrl);
  }

  deleteLockGroup(instanceId: string, tabId?: string): Observable<void> {
    let params = new HttpParams();
    if(tabId)
    {
      params = params.set('tabId', encodeURIComponent(tabId));
    }
    const endpointUrl = `locks/groupdelete/${instanceId}?${params.toString()}`;
    return this.httpClientService.sendDeleteRequest(endpointUrl);
  }

  unlockHostOnUnload(tabId?: string): Observable<void> {
    let params = new HttpParams();
    if(tabId)
    {
      params = params.set('tabId', encodeURIComponent(tabId));
    }
    const endpointUrl = `locks/unlockhost?${params.toString()}`;
    return this.httpClientService.sendPostRequest(endpointUrl, null);
  }
}
